import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CtaButtonProps = {
  label: string;
  href?: string;
  variant?: 'primary' | 'light';
  className?: string;
};
export function CtaButton({
  label,
  href = CHECKOUT_URL,
  variant = 'primary',
  className = ''
}: CtaButtonProps) {
  const base = 'group inline-flex w-full items-center justify-center gap-2 rounded-xl px-4 py-3.5 text-center font-display text-[13px] font-extrabold uppercase leading-tight tracking-tight sm:px-6 sm:py-4 sm:text-base lg:text-lg transition-[transform,background-color,box-shadow] duration-150 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 active:translate-y-[2px]';
  const styles = variant === 'primary' ? 'bg-celeste-deep text-white shadow-cta hover:bg-celeste-deeper active:shadow-[0_3px_0_0_#0f3f63] focus-visible:outline-celeste-deeper' : 'bg-white text-navy shadow-[0_6px_0_0_#c9a24a] hover:bg-celeste-light active:shadow-[0_3px_0_0_#c9a24a] focus-visible:outline-white';
  return <a href={href} className={`${base} ${styles} ${className}`} data-id="element-11" data-mp="39yri3om90coa">
      <span className="font-bold" data-id="element-12" data-mp="39z1656nqg9rc">{label}</span>
      <ArrowRightIcon className="hidden h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1 sm:block" aria-hidden="true" data-id="element-13" data-mp="3exb4tr8o1shp" />
    </a>;
}